module.exports = __webpack_public_path__ + "static/media/wmTrial-words-2.1fa6521b.mp3";